import React from 'react';
import T from 'prop-types';
import { StyledContentWrapper } from '../../../../components/forms/Machines/MachineDetail/elements';
import ConnectedSensorDataContent from './ConnectedSensorDataContent';

const SensorData = ({ plcType }) => (
  <>
    <StyledContentWrapper elevation={3}>
      <ConnectedSensorDataContent plcType={plcType} />
    </StyledContentWrapper>
  </>
);

SensorData.propTypes = {
  plcType: T.shape({
    plc_type: T.string,
    autoconfig_enabled: T.bool
  }).isRequired
};

export default SensorData;
